import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class ListSystemAdminsService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    // private common: DatabaseCacheService
  ) { }

  listSystemAdmins() {

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    let headers = new HttpHeaders({'Content-Type': 'application/json'})
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    return this.httpClient.get(`${apiConfig.uri}/system/admins`, {  headers: headers });
  }
}
